import { z } from 'zod';
export const FacebookLoginSchema = z.object({
    accessToken: z.string().optional(),
    userId: z.string().or(z.number()).optional()
});
//# sourceMappingURL=facebookLoginSchema.js.map